const en = {
  login: 'Log In',
  logout: 'Log Out',
  hello: 'Hello',
  setting: 'Setting',
  back: 'Back',
  startPage: {
    personFile: 'Person File',
    scan: 'Scan',
    startToScan: 'Start To Scan',
    startTip: 'Please scan the ticket or contact the service staff to open the guide service',
  },
  settingPage: {
    privacyTerm: 'Privacy Term',
    serviceTerm: 'Service Term',
  },
  scanPage: {
    scanTitie: 'Please scan the ticket to open the guide service',
    NotAllowedError: 'You must enable camera access',
    NotFoundError: 'This device does not have a camera function',
    NotSupportedError: 'Because of security requirements, it must be used in HTTPS',
    NotReadableError: 'The camera has been used, please close other applications and try again',
    OverconstrainedError: 'Cannot use camera',
    StreamApiNotSupportedError: 'The browser version is too old, please update the browser version',
  },
  loginPage: {
    title: 'Digital Audio Guide Service',
    fbBtn: 'Log in with Facebook',
    googleBtn: 'Log in with Google',
    phoneBtn: 'Log in with mobile SMS',
    loginTip: 'Note: Please be sure to open the browser pop-up window option to complete the Gmail or SMS login. You need to log in to use this digital audio navigation experience. Thank you for your cooperation. ',
    submit: 'Submit',
    textCodeInput: 'Please enter the SMS verification code',
    loginFailed: 'Login failed',
    SMSValidFailed: 'The verification code is wrong, please log in again. ',
    sendSMSFailed: 'Failed to send SMS, please try again later. ',
    borwserFailed: 'Please use chrome browser to open it in order to fully experience this application',
    GPSBrowserFailed: 'This browser cannot use geographic location services, please try another browser. ',
    GPS_ERROR_PERMISSION_DENIED: 'You have rejected the request for geographic location, and you will not be able to use this service. \nPlease turn on the geolocation service permission and refresh the webpage. ',
    GPS_ERROR_POSITION_UNAVAILABLE: 'Location information is not available.',
    GPS_ERROR_TIMEOUT: 'Request user geolocation service timeout',
    GPS_ERROR_UNKNOWN_ERROR: 'Unknown error',
    GPS_ERROR_ORTHER: 'An error occurred.',
  },
  registerPage: {
    submit: 'Submit',
    next: 'Next',
    register: 'Register',
    gender: 'Gender',
    age: 'Age',
    nickname: 'Nickname',
    firstStepTitle: 'Please fill in the basic information to complete the registration',
    firstStepDescription: 'The registration process only takes 30 seconds, please click Next to continue',
    failure: 'Registration failed',
    nameIsRequired: 'Name is required',
    male: 'Male',
    female: 'Female',
  },
  profilePage: {
    name: 'Member Name',
    number: 'Member Number',
    viewLog: 'Viewing Record',
  },
  exhibitionPage: {
    startToTour: 'Start To Tour',
  },
  exhibitionListPage: {
    toggle: 'Switch',
    numberMode: 'Number Mode',
    listMode: 'List Mode',
    title: 'Title',
    errorTip: 'No exhibition information <br/> please contact the staff',
    exhibitionCode: 'Exhibition Number',
    inputTip: 'Please enter the guide number',
    cofirm: 'OK',
    imgAlt: 'A picture of performance',
    notFound: 'Check there is no such code',
    scanError: 'Scanning error occurred, please contact the staff',
  },
  cookies: {
    title: 'Cookies instructions',
    description: 'In order to improve the browsing experience of this website, we will use first-party and third-party cookies. Please understand our',
    cookiesLink: 'Cookies instructions',
    privacyLink: 'User and privacy statement',
    and: 'and',
    close: 'Close',
  },
  errorPage: {
    title: 'Cannot browse this page',
    lead: 'This link may be broken, or the page has been removed. Please confirm that the link you want to open is correct. ',
    contactUs: 'Contact us:',
  },
}

export default en
